export const DARK_PALETTE = [
    "#540B00",
    "#002611",
    "#000E24",
    "#33001C",
    "#000000",
    "#260000",
    "#001B26",
    "#242600",
    "#1D2626",
    "#0A1F0F", // dark green
];
export function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
